import { makeStyles } from '@mui/styles';
import { palette } from '@livable/saas-react-components';
const useStyles = makeStyles({
  section: {
    '& + &': {
      marginTop: 32
    }
  },
  sectionTitle: {
    marginBottom: 12
  },
  sectionHint: {
    color: palette.shades[700],
    marginBottom: 12
  },
  searchField: {
    marginBottom: 12
  },
  propertiesList: {
    maxHeight: 300,
    overflowY: 'auto',
    scrollbarGutter: 'stable',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white
  },
  propertyItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  selectAllItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    borderBottom: "1px solid ".concat(palette.shades[300]),
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: palette.common.white,
    '& .MuiTypography-root': {
      color: palette.primary.main
    }
  },
  propertyItemText: {
    minWidth: 0,
    whiteSpace: 'normal'
  },
  propertyUtilities: {
    color: palette.shades[700]
  },
  emptyState: {
    padding: '16px',
    border: "1px solid ".concat(palette.shades[300]),
    borderRadius: 2,
    backgroundColor: palette.common.white,
    color: palette.shades[700]
  }
});
export default useStyles;